/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPanelDown: {
  name: 'panel-down';
  data: string;
} = {
  name: 'panel-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 .5A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h12a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 14 .5H2Zm12.5 10V2a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v8.5h13Zm-13 1h13V14a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-2.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
